// extracted by mini-css-extract-plugin
export default {"inputAddress":"InputAddress_inputAddress__5w5+q"};